/**
 * useCommandPalette — Zustand store
 *
 * @module command-palette/hooks
 * @version 1.0
 * @updated 2026-04-26
 *
 * @description
 * Estado global mínimo para abrir/cerrar la CommandPalette desde cualquier
 * punto del árbol (botones, atajos de teclado, acciones, etc.) sin prop drilling.
 *
 * Uso:
 *   // Como hook React (reactivo):
 *   const { isOpen, open, close } = useCommandPaletteStore();
 *
 *   // Fuera de un componente (callbacks, handlers):
 *   useCommandPaletteStore.getState().toggle();
 */

import { create } from 'zustand';

interface CommandPaletteState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}));
